/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

/**
 * Contains common options which will be used by common helpers or services
 */
export const commonOptions = {
  /**
   * ```text
   *  xs  0
   *  sm  600px
   *  md  1024px
   *  lg  1280px
   *  xl  1920px
   *  xxl 2560px
   * ```
   *
   * -----
   *
   * Responsive media query flow
   *
   * ```text
   *  0 <-------------- mobile <----------- tablet <----------- desktop
   *  xs <------- sm <----- md <----- lg <----- xl <----- xxl <----- ∞
   *
   *  xxl: (max-width: 2560px) -> match screen size below 2560px
   *  xl:  (max-width: 1920px) -> match screen size below 1920px
   *  lg:  (max-width: 1280px)  -> match screen size below 1280px
   *  md:  (max-width: 1024px)  -> match screen size below 1024px
   *  sm:  (max-width: 600px)  -> match screen size below 600px
   *  xs:  (max-width: 0px)    -> match none
   *
   *  desktop: match all
   *  tablet: (max-width: 1024px) -> match screen size below 1024px
   *  mobile: (max-width: 600px) -> match screen size below 600px
   * ```
   *
   * -----
   *
   * Mobile first media query flow
   *
   * ```text
   *  0 mobile --------------> tablet -----------> desktop -----------> ∞
   *  xs ----------> sm -----> md -----> lg -----> xl -----> xxl -----> ∞
   *
   *  xs:  (min-width: 0px)    -> match all
   *  sm:  (min-width: 600px)  -> match screen size from 600px -> ∞
   *  md:  (min-width: 1024px) -> match screen size from 1024px -> ∞
   *  lg:  (min-width: 1280px) -> match screen size from 1280px -> ∞
   *  xl:  (min-width: 1920px) -> match screen size from 1920px -> ∞
   *  xxl: (min-width: 2560px) -> match screen size from 2560px -> ∞
   *
   *  mobile: match all
   *  tablet: (min-width: 600px)  -> match screen size above 600px
   *  desktop: (min-width: 1024px) -> match screen size above 1024px
   * ```
   *
   * -----
   *
   * By default, most of amb's directives follow responsive flow.
   */
  breakpoints: {
    xs: 0,
    sm: 600,
    md: 1024,
    lg: 1280,
    xl: 1920,
    xxl: 2560
  }
};
